import { invalidateCache } from 'api/urql/helpers/mutation';

export const addAchPaymentMethod = (results, args, cache, info) => {
  invalidateCache('requestor')(results, args, cache, info);
};
